import React from 'react';

type VideoPlayerProps = {
  src: string;
  poster?: string;
  className?: string;
};

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, poster, className }) => {
  return (
    <div className={`rounded-md overflow-hidden ${className}`}>
      <video
       autoPlay
        controls
        poster={poster}
        className="w-full h-full rounded-md"
        preload="metadata"
  
      >
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoPlayer;
